import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["role", "managedTeamsWrapper", "managedTeams", "tournamentWrapper", "tournament"]

  connect() {
    this.sync()
  }

  sync() {
    this.toggle(this.managedTeamsWrapperTarget, this.managedTeamsTarget, this.roleTarget.value === "team_manager")
    this.toggle(this.tournamentWrapperTarget, this.tournamentTarget, this.roleTarget.value === "host")
  }

  toggle(wrapper, select, visible) {
    wrapper.classList.toggle("d-none", !visible)
    select.disabled = !visible

    if (visible) {
      if (select.tomselect) select.tomselect.enable()
      return
    }

    if (select.tomselect) {
      select.tomselect.disable()
      select.tomselect.clear()
    } else {
      Array.from(select.options).forEach((option) => { option.selected = false })
    }
  }
}
